import Vue from 'vue';

const success = (context) => {
  context.getGroupsData();
  toastr.success(context.$t('groups.create_success'));
};

const failed = (context, error) => {
  context.smallLoading = false;
  context.showToasterError(error);
};

export default (context, data) => Vue.$http.post('/web-site-groups', data)
  .then((response) => {
    if (response && response.status === 200) {
      success(context);
    }
  }).catch((error) => {
    failed(context, error);
  });



// WEBPACK FOOTER //
// ./src/app/services/website/createRentalGroup.js